import React from "react";
import { FieldArray } from "redux-form";
import ListingText from "../../../../partials/form/partials/listingText/ListingText";

const AddNewListingText = () => {
  return (
    <div className="container">
        <FieldArray name="texts"  component={ListingText} />
    </div>
  );
};

export default AddNewListingText;
